import styled from '@emotion/styled';

const Balloon:React.FC<any> = ({children}) => {
  return(
    <BalloonContainer>
      <BalloonTail />
      {children}
    </BalloonContainer>
  );
};

export default Balloon;

const BalloonContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-color:rgba(255, 255, 255, 1);

  text-align: center;
  font-size: 16px;
  line-height: 1.2;
  filter: drop-shadow(0px 2px 5px rgba(79, 79, 79, 0.25));
  z-index: 1;
`;

const BalloonTail = styled.div`
  position: absolute;
  bottom: -20px;
  left: 45%;
  transform: translateX(-50%);
  border-style: solid;
  border-width: 5px 15px 20px 15px;
  border-color: transparent transparent rgba(255, 255, 255, 1) transparent;
  transform: rotate(180deg);
  z-index: 0;
`;